"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const employee_entity_1 = require("../../../../service-lib/src/lib/entities/employee.entity");
const employee_hierarchy_entity_1 = require("../../../../service-lib/src/lib/entities/employee_hierarchy.entity");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const employee_dto_1 = require("./dto/employee.dto");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const typeorm_2 = require("@nestjs/typeorm");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const user_role_entity_1 = require("../../../../service-lib/src/lib/entities/user-role.entity");
const password_util_1 = require("../../../../service-lib/src/lib/utils/password.util");
const roles_entity_1 = require("../../../../service-lib/src/lib/entities/roles.entity");
const org_vertical_entity_1 = require("../../../../service-lib/src/lib/entities/org-vertical.entity");
const org_branch_entity_1 = require("../../../../service-lib/src/lib/entities/org-branch.entity");
const department_entity_1 = require("../../../../service-lib/src/lib/entities/department.entity"); // Assuming 'department.entity.ts' is the correct file name
const entities_1 = require("../../../../service-lib/src/lib/entities");
let EmployeeRepository = class EmployeeRepository {
    constructor(dataSource, employeeRepository, entityService, lookUpRepository) {
        this.dataSource = dataSource;
        this.employeeRepository = employeeRepository;
        this.entityService = entityService;
        this.lookUpRepository = lookUpRepository;
    }
    /**
     * Creates a new Employee record in the database.
     */
    async addEmployee(createEmployeeObject, userId) {
        try {
            const response = await this.dataSource.transaction(async (entityManager) => {
                // First validate the user/employee/reporting manager
                await this.validateUserEmployeeIsNew(entityManager, createEmployeeObject);
                await this.validateDeptBranch(entityManager, {
                    departmentId: createEmployeeObject.departmentId,
                    branchId: createEmployeeObject.branchId,
                    verticalId: createEmployeeObject.verticalId,
                    organisationId: createEmployeeObject.organisationId
                });
                const reportingMgr = await this.validateReportingManager(entityManager, createEmployeeObject.reportingManagerEmployeeId, createEmployeeObject.reportees);
                // A placeholder password also needs to be stored in the DB as it is a required field
                const passwordStr = await (0, password_util_1.hashPassword)(String(Date.now()));
                try {
                    // Create User object with fields specific to the User entity
                    const user = await entityManager.create(user_1.User, {
                        salutationLid: createEmployeeObject.salutationLid,
                        firstName: createEmployeeObject.firstName,
                        lastName: createEmployeeObject.lastName,
                        emailId: createEmployeeObject.emailId,
                        mobile: createEmployeeObject.mobile,
                        loginName: createEmployeeObject.emailId,
                        password: passwordStr,
                        branchId: createEmployeeObject.branchId,
                        departmentId: createEmployeeObject.departmentId,
                        designationId: createEmployeeObject.designationId,
                        reportingUserId: reportingMgr.userId,
                        verticalId: createEmployeeObject.verticalId,
                        organisationId: createEmployeeObject.organisationId,
                        userTypeKey: constants_1.USER_TYPE_IIRM_EMPLOYEE,
                        userStatusKey: constants_1.USER_STATUS_ACTIVE,
                        createdBy: userId,
                        updatedBy: userId,
                    });
                    const savedUser = await entityManager.save(user);
                    await this.createRoles(entityManager, createEmployeeObject, savedUser.userId, userId);
                    const employeeActive = await entityManager.findOne(look_up_entity_1.LookUp, {
                        where: { lookUpKey: constants_1.EMPLOYEE_STATUS_ACTIVE },
                    });
                    // Create Employee object with fields specific to the Employee entity
                    const employee = await entityManager.create(employee_entity_1.Employee, {
                        salutationLid: createEmployeeObject.salutationLid,
                        firstName: createEmployeeObject.firstName,
                        lastName: createEmployeeObject.lastName,
                        emailId: createEmployeeObject.emailId,
                        mobile: createEmployeeObject.mobile,
                        userId: savedUser.userId, // Link User to Employee
                        branchId: createEmployeeObject.branchId,
                        departmentId: createEmployeeObject.departmentId,
                        verticalId: createEmployeeObject.verticalId,
                        organisationId: createEmployeeObject.organisationId,
                        designationId: createEmployeeObject.designationId,
                        reportingManagerEmployeeId: reportingMgr.employeeId,
                        statusLid: employeeActive?.id || undefined,
                        iirmEmpId: createEmployeeObject.iirmEmpId,
                        reportingUserId: reportingMgr.userId,
                        createdBy: userId,
                        updatedBy: userId,
                    });
                    const savedEmployee = await entityManager.save(employee);
                    //console.log("savedEmployee: ", savedEmployee);
                    const changeHierarchyList = [];
                    changeHierarchyList.push(savedUser.userId);
                    // Now let us process Reportees
                    if (createEmployeeObject.reportees && createEmployeeObject.reportees.length > 0) {
                        const oldMgrList = await this.addReportees({
                            entityManager, reportees: createEmployeeObject.reportees,
                            employeeId: savedEmployee.employeeId, userId: savedUser.userId,
                            creator: userId
                        });
                        // Add the oldMgrList to changeHierarchyList
                        changeHierarchyList.push(...oldMgrList);
                    }
                    await this.addParentsToUpdateList(entityManager, savedUser.userId, changeHierarchyList);
                    const uniqueList = [...new Set(changeHierarchyList)];
                    console.log("Got unique List: ", uniqueList);
                    // Now update the dependent hierarchy for all these people
                    await this.updateEmployeeHierarchy(entityManager, uniqueList, userId);
                    console.log("Updated Employee Hierarchy: ");
                    // Exclude createdAt, updatedAt, createdBy, updatedBy from the response
                    const { createdAt, updatedAt, createdBy, updatedBy, deletedAt, ...employeeData } = savedEmployee;
                    const updatedEmployee = {
                        ...employeeData,
                    };
                    return updatedEmployee;
                }
                catch (error) {
                    throw error instanceof Error
                        ? new common_1.InternalServerErrorException(`${error.message}`)
                        : new common_1.InternalServerErrorException("An unknown error occurred");
                }
            });
            if (response.employeeId) {
                //return this.getEmployeeById(response.employeeId);
                return response;
            }
        }
        catch (error) {
            throw error instanceof Error
                ? new common_1.InternalServerErrorException(`${error.message}`)
                : new common_1.InternalServerErrorException("An unknown error occurred");
        }
        return null;
    }
    async addReportees({ entityManager, reportees, employeeId, userId, creator }) {
        // validate that all reportees are active status
        const inactiveUsers = await entityManager.find(user_1.User, {
            where: {
                userId: (0, typeorm_1.In)(reportees),
                userStatusKey: {
                    lookUpKey: constants_1.USER_STATUS_DELETED
                }
            },
        });
        if (inactiveUsers && inactiveUsers.length > 0) {
            throw new common_1.BadRequestException(messages_1.infoMessages.inactiveUsersInReportees);
        }
        const oldMgrs = await entityManager.find(user_1.User, {
            where: { userId: (0, typeorm_1.In)(reportees) },
        });
        let mgrsToUpdate = oldMgrs.map(u => u.reportingUserId);
        let uniqueList = [...new Set(mgrsToUpdate)];
        mgrsToUpdate = [...uniqueList];
        await uniqueList.forEach(manager => {
            this.addParentsToUpdateList(entityManager, manager, mgrsToUpdate);
        });
        uniqueList = [...new Set(mgrsToUpdate)];
        // Now update all user rows for reportees with new reporting manager user Id
        await entityManager.update(user_1.User, { userId: (0, typeorm_1.In)(reportees) }, { reportingUserId: userId });
        // Do the same for employee rows
        await entityManager.update(employee_entity_1.Employee, { userId: (0, typeorm_1.In)(reportees) }, { reportingManagerEmployeeId: employeeId, reportingUserId: userId });
        // return the old managers such that their employee_hierarchy table can be updated.
        return uniqueList;
    }
    async addParentsToUpdateList(entityManager, userId, mgrsToUpdate) {
        const rawSqlString = `
      WITH RECURSIVE HierarchyCTE AS (
        SELECT id, reporting_user_id, 0 AS Level
        FROM users WHERE id = ${userId}
        
        UNION ALL
        
        SELECT t.id, t.reporting_user_id, h.Level + 1
        FROM users t
        JOIN HierarchyCTE h ON t.id = h.reporting_user_id
      )
      SELECT id
      FROM HierarchyCTE
      ORDER BY Level, id
    `;
        const dataRows = await entityManager.query(rawSqlString);
        if (dataRows && dataRows.length > 0) {
            mgrsToUpdate.push(...dataRows.map(row => row.id));
        }
    }
    async createRoles(entityManager, createEmployeeObject, savedUserId, creator) {
        // Get unique role IDs to prevent processing duplicates
        const roleIdList = createEmployeeObject && createEmployeeObject.roles.length > 0
            ? createEmployeeObject.roles
            : [];
        const uniqueRoleIds = [...new Set(roleIdList)];
        if (uniqueRoleIds && uniqueRoleIds.length > 0) {
            // Validate that all the roles are valid Roles
            const validRoles = await entityManager.find(roles_entity_1.Role, {
                where: { id: (0, typeorm_1.In)(uniqueRoleIds) },
            });
            if (validRoles.length !== uniqueRoleIds.length) {
                throw new common_1.BadRequestException(messages_1.infoMessages.invalidRolesinCreate);
            }
            const userRoles = await this.createRoleObjs(entityManager, {
                userId: savedUserId,
                roles: uniqueRoleIds,
                creator: creator
            });
            await entityManager.save(user_role_entity_1.UserRole, userRoles);
        }
    }
    async createRoleObjs(entityManager, { userId, roles, creator }) {
        const userRoles = [];
        roles.forEach(roleId => {
            const roleObj = entityManager.create(user_role_entity_1.UserRole, {
                userId: userId,
                roleId: roleId,
                createdBy: creator,
                updatedBy: creator,
            });
            userRoles.push(roleObj);
        });
        return userRoles;
    }
    async updateRoles(entityManager, employeeObject, user, creator) {
        // Update user roles if roles are provided in the update DTO
        const existingRoleIds = user.userRoles.map((ur) => ur.roleId);
        const updateRoleIds = employeeObject.roles || [];
        // Roles to add:
        let rolesToAdd = updateRoleIds.filter((roleId) => !existingRoleIds.includes(roleId));
        // make them unique
        let uniqueList = [...new Set(rolesToAdd)];
        // Add new roles
        if (uniqueList.length > 0) {
            const newUserRoles = await this.createRoleObjs(entityManager, {
                userId: user.userId,
                roles: uniqueList,
                creator: creator
            });
            await entityManager.save(user_role_entity_1.UserRole, newUserRoles);
        }
        // Roles to remove:
        const rolesToRemove = userRoles.filter((ur) => !updateRoleIds.includes(ur.roleId));
        uniqueList = [...new Set(rolesToRemove)];
        // Remove roles not present in payload
        if (uniqueList.length > 0) {
            await entityManager.remove(user_role_entity_1.UserRole, uniqueList);
        }
    }
    async updateReportees(entityManager, user, employeeObject, creator) {
        // Update reportees if reportees are provided in the update DTO
        const existingReportees = await this.getEmployeeHierarchyByUserId(user.userId, false);
        const existingReporteeList = existingReportees.map(e => e.userId);
        const updateReporteesList = employeeObject.reportees || [];
        // Reportees to add:
        const reporteesToAdd = updateReporteesList.filter((userId) => !existingReporteeList.includes(userId));
        const uniqueList = [...new Set(reporteesToAdd)];
        // Reportees to remove:
        const reporteesToRemove = existingReporteeList.filter((userId) => !updateReporteesList.includes(userId));
        // But we can't remove reportees:
        if (reporteesToRemove.length > 0) {
            throw new common_1.BadRequestException(messages_1.infoMessages.cannotRemoveReportees);
        }
        const updateHierarchyList = await this.addReportees({
            entityManager,
            reportees: uniqueList,
            employeeId: employeeObject.employeeId,
            userId: user.userId,
            creator
        });
        return updateHierarchyList;
    }
    async validateUserEmployeeIsNew(entityManager, createEmployeeObject) {
        // Check if the employee already exists
        // Check if either the email or iirmEmpId already exists for an active employee
        const existingEmployee = await entityManager.findOne(employee_entity_1.Employee, {
            where: {
                iirmEmpId: createEmployeeObject.iirmEmpId,
                statusLookup: { lookUpKey: constants_1.EMPLOYEE_STATUS_ACTIVE },
            },
        });
        if (existingEmployee) {
            throw new common_1.BadRequestException(messages_1.infoMessages.employeeIdAlreadyExists);
        }
        await this.validateEmailIsUnique(entityManager, createEmployeeObject.emailId);
    }
    async validateUserEmployeeExists(entityManager, employeeObject) {
        // Check to ensure employee and user exist!
        const employee = await entityManager.findOne(employee_entity_1.Employee, {
            where: { employeeId: employeeObject.employeeId },
        });
        if (!employee) {
            throw new common_1.NotFoundException(messages_1.infoMessages.employeeNotFound);
        }
        ;
        if (employee.userId !== employeeObject.userId) {
            throw new common_1.BadRequestException(messages_1.infoMessages.userIdCantChange);
        }
        const user = await entityManager.findOne(user_1.User, {
            where: { userId: employee.userId },
            include: { userRoles: true },
        });
        if (!user) {
            throw new common_1.NotFoundException(messages_1.infoMessages.userNotFound);
        }
        if (employeeObject.emailId &&
            (employeeObject.emailId !== employee.emailId || employeeObject.emailId !== user.emailId)) {
            // Validate email is unique if it is being updated
            await this.validateEmailIsUnique(entityManager, employeeObject.emailId);
        }
        return { employee, user };
    }
    async validateManagerUserExists(entityManager, userId) {
        if (!userId) {
            throw new common_1.NotFoundException(messages_1.infoMessages.reportingMgrMissingNotFound);
        }
        // Check to ensure employee and user exist!
        const employee = await entityManager.findOne(employee_entity_1.Employee, {
            where: { userId: userId },
        });
        if (!employee) {
            throw new common_1.NotFoundException(messages_1.infoMessages.reportingMgrMissingNotFound);
        }
        ;
        const user = await entityManager.findOne(user_1.User, {
            where: { userId: userId },
        });
        if (!user) {
            throw new common_1.NotFoundException(messages_1.infoMessages.reportingMgrMissingNotFound);
        }
        return { employee, user };
    }
    async validateEmailIsUnique(entityManager, emailId) {
        const isEmailExistsInUser = await entityManager.findOne(user_1.User, {
            where: { emailId: emailId, userStatusKey: constants_1.USER_STATUS_ACTIVE },
        });
        if (isEmailExistsInUser) {
            throw new common_1.BadRequestException(messages_1.infoMessages.employeeEmailIdAlreadyExists);
        }
        const emailInEmployee = await entityManager.findOne(employee_entity_1.Employee, {
            where: {
                emailId: emailId,
                statusLookup: { lookUpKey: constants_1.EMPLOYEE_STATUS_ACTIVE },
            },
        });
        if (emailInEmployee) {
            throw new common_1.BadRequestException(messages_1.infoMessages.employeeEmailIdAlreadyExists);
        }
    }
    async validateDeptBranch(entityManager, { branchId, departmentId, verticalId, organisationId }) {
        const vertical = await entityManager.findOne(org_vertical_entity_1.OrgVertical, {
            where: { id: verticalId, organisationId: organisationId },
        });
        if (!vertical) {
            throw new common_1.BadRequestException(messages_1.infoMessages.invalidOrgVertical);
        }
        const department = await entityManager.findOne(department_entity_1.Department, {
            where: { id: departmentId, verticalId: verticalId },
        });
        if (!department) {
            throw new common_1.BadRequestException(messages_1.infoMessages.invalidOrgVerticalDept);
        }
        const branch = await entityManager.findOne(org_branch_entity_1.OrgBranch, {
            where: { id: branchId, organisationId: organisationId },
        });
        if (!branch) {
            throw new common_1.BadRequestException(messages_1.infoMessages.invalidOrgBranch);
        }
    }
    async validateReportingManager(entityManager, reportingManagerEmployeeId, reportees) {
        let reportingMgr;
        if (reportingManagerEmployeeId &&
            reportingManagerEmployeeId !== 0) {
            reportingMgr = await entityManager.findOne(employee_entity_1.Employee, {
                where: { employeeId: reportingManagerEmployeeId },
            });
            if (!reportingMgr) {
                throw new common_1.BadRequestException(messages_1.infoMessages.invalidReportingManager);
            }
            if (reportees && reportees.find(r => r === reportingMgr.userId)) {
                throw new common_1.BadRequestException(messages_1.infoMessages.reportingMgrInReportees);
            }
        }
        return reportingMgr;
    }
    /**
     * Retrieves Employee records from the database, with optional search, sorting, and pagination.
     */
    async getEmployees(sortArray, searchArray, searchBy, page, limit) {
        try {
            return await this.dataSource.transaction(async (entityManager) => {
                try {
                    const { data, count } = await this.entityService.fetchEntityList(employee_entity_1.Employee, page, limit, sortArray, [
                        "user",
                        "userRoles",
                        "userRoles.role",
                        "department",
                        "vertical",
                        "designation",
                        "organisation",
                        "branch",
                    ], undefined, undefined, searchArray);
                    const statusLid = [
                        ...new Set(data.map((employee) => employee.statusLid).filter(Boolean)),
                    ];
                    const salutationLid = [
                        ...new Set(data.map((employee) => employee.salutationLid).filter(Boolean)),
                    ];
                    const lookUpValues = await this.entityService.getLookupValues([
                        ...statusLid,
                        ...salutationLid,
                    ]);
                    const employeeData = data.map((employee) => {
                        const statusLookup = lookUpValues.find((item) => item.id === employee.statusLid);
                        const salutation = lookUpValues.find((item) => item.id === employee.salutationLid);
                        return this.mapEmployeeToDto({
                            ...employee,
                            statusLookup: statusLookup ?? null,
                            salutation: salutation ?? null,
                        }, false);
                    });
                    return {
                        data: employeeData,
                        count: count,
                    };
                }
                catch (error) {
                    throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "An unknown error occurred");
                }
            });
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            if (error instanceof common_1.BadRequestException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "An unknown error occurred");
        }
    }
    /**
     * Retrieves a single Employee record by its ID.
     */
    async getEmployeeById(employeeId) {
        try {
            // return await this.dataSource.transaction(async (entityManager) => {
            const data = await this.employeeRepository.findOne({
                where: { employeeId: employeeId },
                relations: {
                    user: true,
                    userRoles: {
                        role: true,
                    },
                    designation: true,
                    organisation: true,
                    vertical: true,
                    department: true,
                    branch: true,
                    reportingTo: {
                        department: true,
                        designation: true,
                        organisation: true,
                        userRoles: {
                            role: true,
                        },
                        branch: true,
                    },
                    reportees: {
                        department: true,
                        designation: true,
                        organisation: true,
                        userRoles: {
                            role: true,
                        },
                        branch: true,
                    },
                },
            });
            if (!data) {
                throw new common_1.NotFoundException(`Employee with ID ${employeeId} not found`);
            }
            const employee = data;
            // Extract unique lookup IDs
            const lookupIds = [
                employee.statusLid,
                employee.salutationLid,
                employee.reportingTo?.statusLid,
                employee.reportingTo?.salutationLid,
                ...employee.reportees.flatMap((reportee) => [
                    reportee.statusLid,
                    reportee.salutationLid,
                ]),
            ].filter(Boolean);
            // Fetch lookup values in a single call
            const lookUpValues = await this.entityService.getLookupValues(lookupIds.filter((id) => id !== undefined));
            // Massage the data
            const enrichedEmployee = {
                employeeId: employee.employeeId,
                firstName: employee.firstName,
                lastName: employee.lastName,
                emailId: employee.emailId,
                mobile: employee.mobile,
                userId: employee.userId,
                iirmEmpId: employee.iirmEmpId,
                status: lookUpValues.find((item) => item.id === employee.statusLid),
                loginName: employee.user.loginName,
                salutation: lookUpValues.find((item) => item.id === employee.salutationLid),
                designation: employee.designation
                    ? {
                        id: employee.designation.id,
                        name: employee.designation.name,
                        description: employee.designation.description,
                    }
                    : null,
                organisation: employee.organisation
                    ? {
                        id: employee.organisation.id,
                        name: employee.organisation.name,
                        description: employee.organisation.description,
                    }
                    : null,
                vertical: employee.vertical
                    ? {
                        id: employee.vertical.id,
                        name: employee.vertical.name,
                        description: employee.vertical.description,
                    }
                    : null,
                department: employee.department
                    ? {
                        id: employee.department.id,
                        name: employee.department.name,
                        description: employee.department.description,
                    }
                    : null,
                branch: employee.branch
                    ? {
                        id: employee.branch.id,
                        name: employee.branch.name,
                    }
                    : null,
                userRoles: employee.userRoles.map((userRole) => ({
                    id: userRole.role.id,
                    name: userRole.role.name,
                    description: userRole.role.description,
                })),
                reportingTo: employee.reportingTo
                    ? {
                        employeeId: employee.reportingTo.employeeId,
                        firstName: employee.reportingTo.firstName,
                        lastName: employee.reportingTo.lastName,
                        emailId: employee.reportingTo.emailId,
                        mobile: employee.reportingTo.mobile,
                        userId: employee.reportingTo.userId,
                        designation: employee.reportingTo.designation
                            ? {
                                id: employee.reportingTo.designation.id,
                                name: employee.reportingTo.designation.name,
                                description: employee.reportingTo.designation.description,
                            }
                            : null,
                        organisation: employee.reportingTo.organisation
                            ? {
                                id: employee.reportingTo.organisation.id,
                                name: employee.reportingTo.organisation.name,
                                description: employee.reportingTo.organisation.description,
                            }
                            : null,
                        vertical: employee.reportingTo.vertical
                            ? {
                                id: employee.reportingTo.vertical.id,
                                name: employee.reportingTo.vertical.name,
                                description: employee.reportingTo.vertical.description,
                            }
                            : null,
                        department: employee.reportingTo.department
                            ? {
                                id: employee.reportingTo.department.id,
                                name: employee.reportingTo.department.name,
                                description: employee.reportingTo.department.description,
                            }
                            : null,
                        branch: employee.branch
                            ? {
                                id: employee.branch.id,
                                name: employee.branch.name,
                            }
                            : null,
                        status: lookUpValues.find((item) => item.id === employee.reportingTo?.statusLid),
                        salutation: lookUpValues.find((item) => item.id === employee.reportingTo?.salutationLid),
                        userRoles: employee.reportingTo.userRoles.map((userRole) => ({
                            id: userRole.role.id,
                            name: userRole.role.name,
                            description: userRole.role.description,
                        })),
                    }
                    : null,
                reportees: employee.reportees.map((reportee) => ({
                    employeeId: reportee.employeeId,
                    firstName: reportee.firstName,
                    lastName: reportee.lastName,
                    emailId: reportee.emailId,
                    mobile: reportee.mobile,
                    userId: reportee.userId,
                    designation: reportee.designation
                        ? {
                            id: reportee.designation.id,
                            name: reportee.designation.name,
                            description: reportee.designation.description,
                        }
                        : null,
                    organisation: reportee.organisation
                        ? {
                            id: reportee.organisation.id,
                            name: reportee.organisation.name,
                            description: reportee.organisation.description,
                        }
                        : null,
                    vertical: reportee.vertical
                        ? {
                            id: reportee.vertical.id,
                            name: reportee.vertical.name,
                            description: reportee.vertical.description,
                        }
                        : null,
                    department: reportee.department
                        ? {
                            id: reportee.department.id,
                            name: reportee.department.name,
                            description: reportee.department.description,
                        }
                        : null,
                    branch: reportee.branch
                        ? {
                            id: reportee.branch.id,
                            name: reportee.branch.name,
                        }
                        : null,
                    userRoles: reportee.userRoles.map((userRole) => ({
                        id: userRole.role.id,
                        name: userRole.role.name,
                        description: userRole.role.description,
                    })),
                    status: lookUpValues.find((item) => item.id === reportee.statusLid),
                    salutation: lookUpValues.find((item) => item.id === reportee.salutationLid),
                })),
            };
            return enrichedEmployee;
        }
        catch (error) {
            console.log("error", error);
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "An unknown error occurred");
        }
    }
    async getEmployeeByEmailId(emailId) {
        try {
            // return await this.dataSource.transaction(async (entityManager) => {
            const data = await this.employeeRepository.findOne({
                where: { emailId: emailId }
            });
            if (!data) {
                throw new common_1.NotFoundException(`Employee with Email ID ${emailId} not found`);
            }
            return data;
        }
        catch (error) {
            console.log("error", error);
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "An unknown error occurred");
        }
    }
    /**
     * Updates an existing Employee record by its ID.
     */
    async updateEmployeeById(employeeId, employeeObject, userId) {
        try {
            await this.dataSource.transaction(async (entityManager) => {
                try {
                    const { employee, user } = await this.validateUserEmployeeExists(entityManager, employeeObject);
                    const updateHierarchyList = [];
                    // If manager is changing, validate
                    if (employee.reportingManagerEmployeeId !== employeeObject.reportingManagerEmployeeId) {
                        if (employee.employeeId === employeeObject.reportingManagerEmployeeId) {
                            throw new common_1.BadRequestException(messages_1.infoMessages.reportingMgrSelf);
                        }
                        const reportingMgr = await this.validateReportingManager(entityManager, employeeObject.reportingManagerEmployeeId, employeeObject.reportees);
                        updateHierarchyList.push(reportingMgr.userId);
                        await this.addParentsToUpdateList(entityManager, reportingMgr.userId, updateHierarchyList);
                    }
                    // Validate only if any of them are changing
                    if (employeeObject.departmentId !== employee.departmentId
                        || employeeObject.branchId !== employee.branchId
                        || employeeObject.verticalId !== employee.verticalId
                        || employeeObject.organisationId !== employee.organisation_id) {
                        this.validateDeptBranch(entityManager, {
                            departmentId: employeeObject.departmentId,
                            branchId: employeeObject.branchId,
                            verticalId: employeeObject.verticalId,
                            organisationId: employeeObject.organisationId
                        });
                    }
                    entityManager.merge(user_1.User, user, {
                        ...employeeObject, loginName: employeeObject.emailId, updatedBy: userId,
                    });
                    await entityManager.save(user);
                    await this.updateRoles(entityManager, employeeObject, user, userId);
                    // Update Employee
                    entityManager.merge(employee_entity_1.Employee, employee, { ...employeeObject, updatedBy: userId });
                    await entityManager.save(employee);
                    // Process Reportees
                    const updateMgrList = await this.updateReportees(entityManager, user, employeeObject, userId);
                    updateHierarchyList.push(...updateMgrList);
                    const uniqueList = [...new Set(updateHierarchyList)];
                    // Now update the dependent hierarchy for all these people
                    await this.updateEmployeeHierarchy(entityManager, uniqueList, userId);
                }
                catch (error) {
                    if (error instanceof Error) {
                        throw new common_1.InternalServerErrorException(`${error.message}`);
                    }
                    else {
                        throw new common_1.InternalServerErrorException("An unknown error occurred");
                    }
                }
            });
        }
        catch (error) {
            if (error instanceof Error) {
                throw new common_1.InternalServerErrorException(`${error.message}`);
            }
            else {
                throw new common_1.InternalServerErrorException("An unknown error occurred");
            }
        }
        // Return the updated employee details
        return true;
    }
    /**
     * Removes an employee by setting their status to inactive and reassigning their
     * reportees to a new manager. Any ownership of companies and opportunities should
     * be changed to the delegateOwner.
     */
    async deleteEmployeeById(employeeId, delegateOwnerUserId, newManagerUserId) {
        try {
            const result = await this.dataSource.transaction(async (entityManager) => {
                try {
                    const { employee, user } = await this.validateUserEmployeeExists(entityManager, employeeId);
                    const delegateUser = await entityManager.findOne(user_1.User, {
                        where: { userId: delegateOwnerUserId },
                    });
                    if (!delegateUser) {
                        throw new common_1.NotFoundException(messages_1.infoMessages.delegateUserNotFound);
                    }
                    // Find all active reportees of the employee
                    const reportees = await entityManager.find(user_1.User, {
                        where: {
                            reportingUserId: user.userId,
                            userStatusKey: constants_1.USER_STATUS_ACTIVE,
                        },
                    });
                    const updateHierarchyList = [user.userId];
                    await this.addParentsToUpdateList(entityManager, user.userId, updateHierarchyList);
                    if (reportees && reportees.length > 0) {
                        // Check if the new manager exists and is active
                        const { newMgrEmployee, newMgrUser } = await this.validateManagerUserExists(entityManager, newManagerUserId);
                        // Update the user and employee tables to set the reporting user Id 
                        // and reporting Mgr Id to the new manager for all the reportees
                        const reporteeIdList = reportees.map(r => r.userId);
                        entityManager.update(user_1.User, {
                            userId: (0, typeorm_1.In)(reporteeIdList)
                        }, {
                            reportingUserId: newMgrUser.userId,
                        });
                        entityManager.update(employee_entity_1.Employee, {
                            userId: (0, typeorm_1.In)(reporteeIdList)
                        }, {
                            reportingUserId: newMgrUser.userId,
                            reportingManagerEmployeeId: newMgrEmployee.employeeId,
                        });
                        updateHierarchyList.push(newMgrUser.userId);
                        await this.addParentsToUpdateList(entityManager, user.userId, updateHierarchyList);
                    }
                    const lookupIds = await entityManager.getRepository(look_up_entity_1.LookUp).find({
                        where: { lookUpKey: (0, typeorm_1.In)([constants_1.EMPLOYEE_STATUS_INACTIVE,
                                constants_1.OPTY_STAGE_WIP,
                                constants_1.OPTY_STAGE_OPEN,
                                constants_1.ACTIVITY_STATUS_COMPLETED
                            ])
                        },
                    });
                    const inActiveStatus = lookupIds?.find(l => l.lookUpKey === constants_1.EMPLOYEE_STATUS_INACTIVE);
                    const optyOpen = lookupIds?.find(l => l.lookUpKey === constants_1.OPTY_STAGE_OPEN);
                    const optyWIP = lookupIds?.find(l => l.lookUpKey === constants_1.OPTY_STAGE_WIP);
                    const activityCompleted = lookupIds?.find(l => l.lookUpKey === constants_1.ACTIVITY_STATUS_COMPLETED);
                    if (!inActiveStatus || !optyOpen || !optyWIP) {
                        throw new common_1.NotFoundException("Lookups for Employee Status or Opportunity Stages not found");
                    }
                    // We should change ownership of any company & opportunity objects to
                    // the delegated user.
                    await entityManager.update(entities_1.Company, {
                        leadCRM: user.userId,
                    }, {
                        leadCrm: delegateUser.userId,
                    });
                    await entityManager.update(entities_1.Company, {
                        accountManager: user.userId,
                    }, {
                        accountManager: delegateUser.userId,
                    });
                    // @TODO: Update Opportunity & Activity Maps also!
                    /*
                    ** Should we update only Open & WIP Opportunities only?? or all of them?
                    await entityManager.update(Opportunity, {
                      leadCrm: user.userId,
                      stageLid: In([optyOpen.id, optyWIP.id]),
                    }, {
                      leadCrm: delegateUser.userId
                    })
                    await entityManager.update(OpportunityActivityMap, {
                      activityOwnerId: user.userId,
                      statusLid: Not(activityCompleted?.id),
                    }, {
                      activityOwnerId: delegateUser.userId
                    })
          
                    */
                    // Update employee and user tables for the employee being deleted
                    await entityManager.update(user_1.User, { userId: employee.userId }, {
                        userStatusKey: constants_1.USER_STATUS_DELETED,
                    });
                    await entityManager.update(employee_entity_1.Employee, { employeeId: employee.employeeId }, {
                        statusLid: inActiveStatus.id,
                    });
                    return true;
                }
                catch (error) {
                    if (error instanceof Error) {
                        throw new common_1.InternalServerErrorException(`${error.message}`);
                    }
                    else {
                        throw new common_1.InternalServerErrorException("An unknown error occurred");
                    }
                }
            });
            return result;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new common_1.InternalServerErrorException(`${error.message}`);
            }
            else {
                throw new common_1.InternalServerErrorException("An unknown error occurred");
            }
        }
    }
    /**
     * THIS NEEDS UPDATING BASED ON ALL THE CHANGES TO THE EMPLOYEE ADDITION @TODO
     * NOT SURE IF THIS FUNCTIONALITY IS NEEDED OR SUPPORTED BY BUSINESS REQUIREMENTS
     * MAY HAVE TO DISABLE THE ENDPOINT
     * Moves an employee to leave status and assigns a delegate.
     */
    async moveEmployeeToLeave(employeeId, delegateId) {
        // Check if the employee exists
        const employee = await this.employeeRepository.findOne({
            where: { employeeId: employeeId },
        });
        if (!employee) {
            throw new common_1.NotFoundException(`Employee with ID ${employeeId} not found`);
        }
        // Check if the delegate exists
        const delegate = await this.employeeRepository.findOne({
            where: { employeeId: delegateId },
        });
        if (!delegate) {
            throw new common_1.NotFoundException(`Delegate with ID ${delegateId} not found`);
        }
        const leaveStatus = await this.dataSource.getRepository(look_up_entity_1.LookUp).findOne({
            where: { lookUpKey: constants_1.EMPLOYEE_STATUS_LEAVE },
        });
        if (!leaveStatus) {
            throw new common_1.NotFoundException("Leave status lookup not found");
        }
        const reportees = await this.employeeRepository.find({
            where: { reportingManagerEmployeeId: employeeId },
        });
        for (const reportee of reportees) {
            reportee.reportingManagerEmployeeId = delegateId;
            await this.employeeRepository.save(reportee);
        }
        // Update the employee's status to Leave and assign the delegate
        employee.statusLid = leaveStatus.id;
        await this.employeeRepository.save(employee);
    }
    /**
     * Retrieves all employees reporting to a specific manager.
     */
    async getEmployeesByManagerId(managerId) {
        return this.employeeRepository.find({
            where: { reportingManagerEmployeeId: managerId },
        });
    }
    /**
     * Retrieves the employees with few values.
     */
    async getListOfEmployeesValues(sortArray, searchArray, searchBy, page, limit) {
        try {
            const selectedFields = [
                "employeeId",
                "firstName",
                "emailId",
                "statusLid",
            ];
            const inactiveStatus = await this.dataSource
                .getRepository(look_up_entity_1.LookUp)
                .findOne({
                where: { lookUpKey: constants_1.EMPLOYEE_STATUS_INACTIVE },
            });
            const leaveStatus = await this.dataSource.getRepository(look_up_entity_1.LookUp).findOne({
                where: { lookUpKey: constants_1.EMPLOYEE_STATUS_LEAVE },
            });
            const { data, count } = await this.entityService.fetchEntityList(employee_entity_1.Employee, page, limit, sortArray, undefined, {
                statusLid: (0, typeorm_1.Not)(inactiveStatus.id),
            }, selectedFields, searchArray);
            return {
                data: data.map((employee) => ({
                    employeeId: employee.employeeId,
                    firstName: employee.firstName,
                    emailId: employee.emailId,
                })),
                count,
            };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to fetch employee list");
        }
    }
    /**
     * Removes specific fields from an object.
     */
    removeFields(obj, additionalFieldsToRemove = []) {
        const defaultFieldsToRemove = [
            constants_1.EMPLOYEE_FIELDS.CREATED_AT,
            constants_1.EMPLOYEE_FIELDS.UPDATED_AT,
            constants_1.EMPLOYEE_FIELDS.CREATED_BY,
            constants_1.EMPLOYEE_FIELDS.UPDATED_BY,
            constants_1.EMPLOYEE_FIELDS.STATUS_LID,
            constants_1.EMPLOYEE_FIELDS.ORGANIZATION_LID,
            constants_1.EMPLOYEE_FIELDS.BRANCH_LID,
            constants_1.EMPLOYEE_FIELDS.DEPARTMENT_ID,
            constants_1.EMPLOYEE_FIELDS.DESIGNATION_ID,
            // EMPLOYEE_FIELDS.LOCATION_ID,
            constants_1.EMPLOYEE_FIELDS.VERTICAL_ID,
            constants_1.EMPLOYEE_FIELDS.IWORK_ROLE_ID,
            constants_1.EMPLOYEE_FIELDS.REPORTING_USER_ID,
            constants_1.EMPLOYEE_FIELDS.REPORTING_MANAGER_EMPLOYEE_ID,
            constants_1.EMPLOYEE_FIELDS.STATUS_LOOKUP,
            constants_1.EMPLOYEE_FIELDS.SALUTATION_LID,
            constants_1.EMPLOYEE_FIELDS.ROLE_ID,
            constants_1.EMPLOYEE_FIELDS.DELETED_AT,
        ];
        const fieldsToRemove = [
            ...defaultFieldsToRemove,
            ...additionalFieldsToRemove,
        ];
        return Object.keys(obj).reduce((result, key) => {
            if (!fieldsToRemove.includes(key)) {
                result[key] = obj[key];
            }
            return result;
        }, {});
    }
    /**
     * Maps an Employee entity to an EmployeeDto with improved error handling
     */
    mapEmployeeToDto(employee, isGetById) {
        try {
            return new employee_dto_1.EmployeeDto({
                ...this.removeFields(employee),
                status: employee.statusLookup ?? null,
                salutation: employee.salutation ?? null,
                branch: employee.branch
                    ? {
                        id: employee.branch.id,
                        name: employee.branch.name,
                    }
                    : null,
                userRoles: employee.userRoles
                    ? employee.userRoles.map((userRole) => ({
                        id: userRole.id,
                        roleId: userRole.role.id,
                        roleName: userRole.role.name,
                        roleDescription: userRole.role.description,
                    }))
                    : [],
                reportingTo: employee.reportingTo
                    ? this.mapReportingToDto(employee.reportingTo)
                    : null,
                reportees: employee.reportees
                    ? this.mapReporteesDto(employee.reportees)
                    : null,
            });
        }
        catch (error) {
            throw new common_1.InternalServerErrorException("Error mapping employee data");
        }
    }
    /**
     * Helper method to map entity without common fields
     */
    mapEntityWithoutCommonFields(entity) {
        if (!entity)
            return null;
        return this.removeFields(entity, [
            "description",
            "lookUpValueKey",
            "lookUpName",
            "lookUpKey",
        ]);
    }
    /**
     * Helper method to map reporting to DTO
     */
    mapReportingToDto(reportingTo) {
        return new employee_dto_1.EmployeeDto({
            ...this.removeFields(reportingTo),
            status: reportingTo.statusLookup ?? null,
            salutation: reportingTo.salutation ?? null,
            iworkRole: reportingTo.iworkRole ?? null,
            // location: this.mapEntityWithoutCommonFields(reportingTo.location) ?? null,
            vertical: reportingTo.vertical ?? null,
            branch: reportingTo.branch ?? null,
            role: this.mapEntityWithoutCommonFields(reportingTo.role) ?? null,
        });
    }
    /**
     * Helper method to map reportees DTO
     */
    mapReporteesDto(reportees) {
        return reportees.map((reportee) => new employee_dto_1.EmployeeDto({
            ...this.removeFields(reportee),
            status: reportee.statusLookup ?? null,
            salutation: reportee.salutation ?? null,
            iworkRole: reportee.iworkRole ?? null,
            // location:
            //   this.mapEntityWithoutCommonFields(reportee.location) ?? null,
            vertical: reportee.vertical ?? null,
            branch: reportee.branch ?? null,
            role: this.mapEntityWithoutCommonFields(reportee.role) ?? null,
        }));
    }
    /**
     * Retrieves the hierarchy for a given root userId.
     * The SQL logic to fetch the hierarchy will be implemented here.
     */
    async getEmployeeHierarchyByUserId(userId, parentFlag = false) {
        const lookup = await this.lookUpRepository.findOne({
            where: { lookUpKey: constants_1.USER_STATUS_ACTIVE },
        });
        const joinString = (parentFlag)
            ? 't.id = h.reporting_user_id'
            : 't.reporting_user_id = h.id';
        const rawSqlString = `
      WITH RECURSIVE HierarchyCTE AS (
        SELECT id, reporting_user_id, first_name, last_name, 0 AS Level,
          organisation_id, vertical_id, department_id, branch_id
        FROM users WHERE id = ${userId}
        
        UNION ALL
        
        SELECT t.id, t.reporting_user_id, t.first_name, t.last_name, h.Level + 1,
          t.organisation_id, t.vertical_id, t.department_id, t.branch_id
        FROM users t
        JOIN HierarchyCTE h ON ${joinString}
        WHERE t.status_lid = ${lookup?.id}
      )
      SELECT id, reporting_user_id, first_name, last_name, Level,
        organisation_id, vertical_id, department_id, branch_id
      FROM HierarchyCTE
      ORDER BY Level, id
      limit 200
    `;
        const dataRows = await this.dataSource.query(rawSqlString);
        if (!dataRows || dataRows.length === 0) {
            return null;
        }
        const users = [];
        dataRows.forEach(row => {
            users.push({
                userId: row.id,
                firstName: row.first_name,
                lastName: row.last_name,
                reportingUserId: row.reporting_user_id,
                level: row.level,
                organisationId: row.organisation_id,
                verticalId: row.vertical_id,
                departmentId: row.department_id,
                branchId: row.branch_id
            });
        });
        return users;
    }
    async getParentUserWithPrivilege(userId, aclCategoryKey, aclActionKey) {
        // First get the parent hierarchy for this user.
        const parentHierarchy = await this.getEmployeeHierarchyByUserId(userId, true);
        if (!parentHierarchy || parentHierarchy.length === 0) {
            // No parent hierarchy found, so no parents can have the privilege
            return null;
        }
        const parentIds = parentHierarchy.filter(u => u.userId !== userId)
            .map(u => u.userId);
        if (parentIds.length === 0) {
            return null;
        }
        const parentIdStr = parentIds.join(',');
        // Find users with the given privilege from within parentIds - 
        // those users who have the corresponding roles that are in turn mapped to aclCategory & aclAction
        const rawQuery = `
      SELECT DISTINCT ur.user_id AS "userId"
      FROM user_role ur
      JOIN roles r ON ur.role_id = r.id
      JOIN role_acl_category_action_map racam ON r.id = racam.role_id
      JOIN acl_category_action_map acam ON racam.acl_category_action_id = acam.id
      JOIN acl_categories ac ON acam.acl_category_id = ac.id
      JOIN acl_actions aa ON acam.acl_action_id = aa.id
      WHERE ur.user_id IN (${parentIdStr})
      AND ac.category_key = '${aclCategoryKey}'
      AND aa.action_key = '${aclActionKey}'
    `;
        const usersWithPrivilege = await this.dataSource.query(rawQuery);
        if (!usersWithPrivilege || usersWithPrivilege.length === 0) {
            return null;
        }
        // Lets process the usersWithPrivilege and find the user at the lowest level
        // with the privilege. The original user's level is 0 and can be skipped
        // const privilegedUserIdsSet = new Set(usersWithPrivilege.map(row => row.userId));
        const parentObj = parentHierarchy.find((u) => usersWithPrivilege.find(up => up.userId === u.userId));
        return parentObj || null;
    }
    // Get all users with a certain privilege (e.g., assigning an ISG user to Oppty)
    async getAllUsersWithPrivilege(aclCategoryKey, aclActionKey, page, limit) {
        // Find users with the given privilege from within parentIds - 
        // those users who have the corresponding roles that are in turn mapped to aclCategory & aclAction
        const rawQuery = `
      SELECT DISTINCT ur.user_id AS userId,
        u.first_name AS firstName,
        u.last_name AS lastName,
        u.reporting_user_id AS reportingUserId,
        u.organisation_id AS organisationId,
        u.vertical_id AS verticalId,
        u.department_id AS departmentId,
        u.branch_id AS branchId,
        dg.name AS designationName,
        dg.grade_level as gradeLevel
      FROM user_role ur
      JOIN users u ON ur.user_id = u.id
      JOIN designation dg ON u.designation_id = dg.id
      JOIN roles r ON ur.role_id = r.id
      JOIN role_acl_category_action_map racam ON r.id = racam.role_id
      JOIN acl_category_action_map acam ON racam.acl_category_action_id = acam.id
      JOIN acl_categories ac ON acam.acl_category_id = ac.id
      JOIN acl_actions aa ON acam.acl_action_id = aa.id
      WHERE ac.category_key = '${aclCategoryKey}'
        AND aa.action_key = '${aclActionKey}'
      ORDER BY dg.grade_level ASC
      LIMIT ${limit} OFFSET ${(page - 1) * limit}
    `;
        const usersWithPrivilege = await this.dataSource.query(rawQuery);
        return usersWithPrivilege && usersWithPrivilege.length > 0
            ? usersWithPrivilege
            : [];
    }
    // Update the User Hierarchy flat list for all the given userIds
    async updateEmployeeHierarchy(entityManager, userIds, creator) {
        // Delete the EmployeeHierarchy object for each of the userIds
        await entityManager.delete(employee_hierarchy_entity_1.EmployeeHierarchy, { userId: (0, typeorm_1.In)(userIds) });
        await userIds.forEach(userId => {
            this.addToFlatHierarchy(entityManager, userId, creator);
        });
    }
    async addToFlatHierarchy(entityManager, userId, creator) {
        const rawSqlString = `
      WITH RECURSIVE HierarchyCTE AS (
        SELECT id, reporting_user_id, 1 AS lvl
        FROM users
        WHERE id = ${userId}

        UNION ALL

        SELECT u.id, u.reporting_user_id, h.lvl + 1 AS lvl
        FROM users u
        JOIN HierarchyCTE h
          ON u.reporting_user_id = h.id
      )
      INSERT INTO employee_hierarchy (
        user_id, reporting_user_id, created_by, updated_by
      )
      SELECT id, ${userId}, ${creator}, ${creator}
      FROM HierarchyCTE
      WHERE id != ${userId}
      ORDER BY lvl, id;
    `;
        await entityManager.query(rawSqlString);
    }
    /**
     * Rebuilds the entire employee_hierarchy table.
     * This method iterates through all users and reconstructs their hierarchy.
     * Note: This can be a long-running operation on large datasets.
     */
    async rebuildFlatHierarchy(creator = constants_1.DEFAULT_ADMIN_ID) {
        // Rebuild the hierarchy for all users in the user table.
        await this.dataSource.transaction(async (entityManager) => {
            try {
                // 1. Clear the existing employee_hierarchy table
                await entityManager.clear(employee_hierarchy_entity_1.EmployeeHierarchy);
                console.log("Cleared EmployeeHierarchy table.");
                // 2. Fetch users in batches and rebuild hierarchy
                let page = 0;
                const batchSize = 10;
                let usersBatch;
                do {
                    usersBatch = await entityManager.find(user_1.User, {
                        skip: page * batchSize,
                        take: batchSize,
                        select: ["userId"], // Only need the user ID
                    });
                    for (const user of usersBatch) {
                        await this.addToFlatHierarchy(entityManager, user.userId, creator);
                    }
                    page++;
                } while (usersBatch && usersBatch.length > 0);
                console.log("Successfully rebuilt EmployeeHierarchy table.");
            }
            catch (error) {
                console.error("Error rebuilding flat hierarchy:", error);
                throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to rebuild employee hierarchy");
            }
        });
    }
    /**
     * Updates the password for the user and employee tables.
     * @param userId - ID of the user whose password should be updated.
     * @param hashedPassword - New hashed password.
     */
    async updateUserPassword(userId, hashedPassword) {
        await this.dataSource.transaction(async (manager) => {
            await manager.update(user_1.User, { userId }, { password: hashedPassword });
        });
    }
};
exports.EmployeeRepository = EmployeeRepository;
exports.EmployeeRepository = EmployeeRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(1, (0, typeorm_2.InjectRepository)(employee_entity_1.Employee)),
    tslib_1.__param(3, (0, typeorm_2.InjectRepository)(look_up_entity_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _a : Object, typeof (_b = typeof typeorm_1.Repository !== "undefined" && typeorm_1.Repository) === "function" ? _b : Object, typeof (_c = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _c : Object, typeof (_d = typeof typeorm_1.Repository !== "undefined" && typeorm_1.Repository) === "function" ? _d : Object])
], EmployeeRepository);
